import { ComponentType, SVGProps } from 'react';
import { useLanguage } from '@/hooks/useLanguage';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

/**
 * Returns whichever icon matches the current reading direction.
 * `ltr`/`rtl` name which icon to show when the page reads LTR vs RTL
 * — for a "next" chevron that's ChevronRight in LTR and ChevronLeft in RTL.
 */
export function useDirectionalIcon(ltr: IconComponent, rtl: IconComponent): IconComponent {
  const { isRTL } = useLanguage();
  return isRTL ? rtl : ltr;
}
